import React, { Component } from 'react';

import SocialShare from '../../components/SocialShare'
import Gallery from '../../components/Gallery'

import { connect } from 'react-redux'
import { fetchNews } from '../../actions/news'

class NewsDetails extends Component {
    state={}
    componentDidMount = () => {
        const id = this.props.match.params.id
        this.props.fetchNews(id)
    }
    DisplayImageFile = (type) => {
        switch (type) {
            case "pdf":
                return '/resources/images/ic-pdf.svg'
            case "mp3":
                return '/resources/images/ic-mp3.svg'
            default:
                return '/resources/images/image-pdf-mock.png'
        }
    }
    render() {
        if(Object.keys(this.props.news).length > 0){
            const {title, created, detail, cover, images, files} = this.props.news
            console.log(this.props.news)
            return (
                <div className="news-detail-page-wrap">
                    <div className="news-detail-topic">{title}</div>
                    <div className="news-detail-date gapb-24">{created}</div>
                    <div className="news-detail-image gapb-24">
                        <img src={cover} alt="news"/>
                    </div>
                    <div className="gapb-24">
                        <SocialShare/>
                    </div>
                    <div className="news-detial-content">
                        <div  dangerouslySetInnerHTML={{ __html: detail }}/>
                    </div>
                        {images.length > 0 &&
                            <div className="gallery-wrap gapt-32">
                                <div className="gallery-title">Gallery</div>
                                <Gallery
                                    images={images.map((images) => {
                                        return { src: images.path }
                                    })}
                                />
                            </div>
                        }
                        {/* {files.length > 0 && 
                            <div className="file-wrap">
                                <div className="file-title">ไฟล์อ้างอิง</div>
                                <div className="file-list-wrap">
                                {
                                    files.map((file, index) => (
                                        <div className="file-item is-row" key={index}>
                                            <div className="file-item-img gapr-12">
                                                <img src={this.DisplayImageFile(file.extension)} alt="file"/>
                                            </div>
                                            <a className="file-name" href="/">{file.name}</a>
                                        </div>
                                    ))
                                }
                                </div>
                            </div>
                        } */}
                </div>
            )
        } else return null
    }
}

const mapStateToProps = (state) => {
	return {
		auth: state.auth,
		user: state.user,
		news: state.news
	}
}

const mapDispatchToProps = {
	fetchNews
}

export default connect(mapStateToProps, mapDispatchToProps)(NewsDetails)
